<template>
  <div class="audio-player__wrapper">
    <BRow class="h-100">
      <BCol md="1">
        <div class="d-flex flex-column justify-content-center h-100 pl-5">
          <span class="audio-player__chapter-name font-weight-bold fa-x">
            {{ getChapterName }}
          </span>
        </div>
      </BCol>
      <BCol md="11">
        <div class="d-flex flex-column justify-content-center h-100 pr-5 pl-5">
          <AudioPlayer
              :chapters="chapters"
              :currentChapter="currentChapter"
              @setCurrentChapter="setCurrentChapter"
          />
        </div>
      </BCol>
    </BRow>
  </div>
</template>

<script>
import AudioPlayer from "./AudioPlayer";

export default {
  name: "AudioPlayerFix",
  props: {
    chapters: Array,
    currentChapter: Object
  },
  components: {
    AudioPlayer
  },
  computed: {
    getChapterName() {
      return this.currentChapter ? this.currentChapter.name : null;
    }
  },
  methods: {
    setCurrentChapter(chapterId) {
      this.$emit('setCurrentChapter', chapterId)
    }
  }
}
</script>

<style scoped lang="scss">
$purple: #8E8AD3;

.audio-player__wrapper{
  position: fixed;
  background: #F8F8F8;
  bottom: 0;
  left: 0;
  right: 0;
  height: 15%;
  .audio-player__chapter-name{
    color: $purple;
  }
}
</style>